"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Trans } from "@lingui/macro";

const CookieBanner = ({ lang, slug }: { lang: string; slug: string }) => {
  const [open, setOpen] = useState<boolean>(false);

  const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift();
    return undefined;
  };

  const setCookie = (name: string, value: string, days: number) => {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  };

  useEffect(() => {
    const cookieConsent = getCookie("cookieConsent");
    if (cookieConsent === "true") {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setCookie("cookieConsent", "true", 365);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed bottom-0 left-0 z-50 flex w-full flex-col items-center justify-between bg-primary p-4 sm:flex-row">
      <div className="text-sm leading-5 text-white">
        <Trans>
          This Website uses cookies to ensure you get the best experience on our Website.
        </Trans>
        <Link href={`/${lang}/information/${slug}`} prefetch={false} className="pl-1 underline">
          <Trans>Learn More.</Trans>
        </Link>
      </div>
      <button
        onClick={handleClose}
        className="mt-4 w-full min-w-[64px] bg-[#13A7BB] px-4 py-2 text-xs text-white hover:bg-[#39CDE1] sm:mt-0 md:w-min"
      >
        <Trans>Ok</Trans>
      </button>
    </div>
  );
};

export default React.memo(CookieBanner);
